import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseKey)

/**
 * Helper to detect tenant from subdomain
 * @deprecated Use functions from './tenant.js instead. This file now only exports supabase client.
 * The new tenant detection uses path-based routing (/tenantId/login) instead of subdomain (tenantId.domain.com).
 * 
 * Import { getTenantFromPath } from './tenant' for new code.
 */
export const getTenantSubdomain = () => {
  const host = window.location.host
  const parts = host.split('.')
  
  // Skip deployment platforms (Netlify, Vercel, etc.)
  const platformDomains = ['netlify.app', 'vercel.app', 'pages.dev', 'github.io', 'onrender.com']
  const isPlatformDomain = platformDomains.some(domain => host.includes(domain))
  
  if (isPlatformDomain) {
    return null
  }
  
  // admin.classroomdragon.com -> null (admin portal)
  // schoolname.classroomdragon.com -> "schoolname" (school portal)
  if (parts.length >= 3 && parts[0] !== 'www' && parts[0] !== 'admin') {
    return parts[0]
  }
  return null
}
